import React from "react";

// Shared page primitives: header, KPI stat, honest loading / empty / error states.
export function PageHeader({ title, subtitle, right, testid }) {
  return (
    <div className="flex items-start gap-3 flex-wrap" data-testid={testid}>
      <div>
        <h1 className="font-heading text-xl font-bold tracking-tight">{title}</h1>
        {subtitle && <p className="text-xs text-muted-foreground mt-0.5">{subtitle}</p>}
      </div>
      {right && <div className="ml-auto flex items-center gap-2">{right}</div>}
    </div>
  );
}

export function Panel({ title, right, children, className = "", testid }) {
  return (
    <section className={`bg-panel border border-border rounded-xl ${className}`} data-testid={testid}>
      {(title || right) && (
        <div className="flex items-center gap-2 px-4 py-2.5 border-b border-border">
          <h2 className="text-sm font-semibold">{title}</h2>
          {right && <div className="ml-auto flex items-center gap-2">{right}</div>}
        </div>
      )}
      <div className="p-4">{children}</div>
    </section>
  );
}

export function Stat({ label, value, tone, sub, testid }) {
  const color = tone === "buy" ? "text-buy" : tone === "sell" ? "text-sell" : tone === "primary" ? "text-primary" : "text-foreground";
  return (
    <div className="bg-panel border border-border rounded-xl px-4 py-3" data-testid={testid}>
      <div className="text-[10px] uppercase tracking-wide text-muted-foreground">{label}</div>
      <div className={`text-lg font-bold font-mono-nums mt-0.5 ${color}`}>{value}</div>
      {sub && <div className="text-[11px] text-muted-foreground mt-0.5">{sub}</div>}
    </div>
  );
}

export function State({ loading, error, empty, emptyText = "Nothing here yet.", children, testid }) {
  if (loading) return <div className="py-10 text-center text-sm text-muted-foreground animate-pulse" data-testid={`${testid}-loading`}>Loading…</div>;
  if (error) return <div className="py-10 text-center text-sm text-sell" data-testid={`${testid}-error`}>{String(error)}</div>;
  if (empty) return <div className="py-10 text-center text-sm text-muted-foreground" data-testid={`${testid}-empty`}>{emptyText}</div>;
  return children;
}

export const Pill = ({ on, tone = "primary", children, testid, onClick }) => (
  <button data-testid={testid} onClick={onClick} className={`px-2 py-0.5 rounded-full text-[10px] font-semibold border ${on ? (tone === "buy" ? "bg-buy/15 text-buy border-buy/40" : tone === "sell" ? "bg-sell/15 text-sell border-sell/40" : "bg-primary/15 text-primary border-primary/40") : "text-muted-foreground border-border"} ${onClick ? "hover:bg-secondary" : "cursor-default"}`}>{children}</button>
);

export const Check = ({ ok }) => <span className={ok ? "text-buy" : "text-muted-foreground/50"}>{ok ? "✓" : "—"}</span>;
export const ScoreBadge = ({ score, direction }) => (
  <span className={`inline-flex items-center justify-center min-w-[34px] px-1.5 h-6 rounded-md font-mono-nums font-bold text-xs ${score >= 80 ? "bg-buy/20 text-buy" : score >= 60 ? "bg-primary/20 text-primary" : "bg-secondary text-muted-foreground"}`}>{score}{direction === "bullish" ? " ▲" : direction === "bearish" ? " ▼" : ""}</span>
);
